import React from "react";
import { HubFilterMenu } from "../../components";
import { useGetAllBoxCustomers } from "../../hooks";

const ShipmentOrdersCustomerFilter = ({ buttonProps }) => {
  const { data } = useGetAllBoxCustomers();
  const options = data || [];

  return (
    <HubFilterMenu
      id="customer"
      options={options}
      menuLabel="Filter By Customer"
      icon="User"
      label="Customer"
      multiSelect={false}
      useDefault={false}
      buttonProps={buttonProps}
    />
  );
};

export default ShipmentOrdersCustomerFilter;
